import { canTurnTo, getToken, addRouterHistory } from '../util/libs'
import store from '../store'
import Main from '../components/main/main'
// import MyEditor from '../views/editor'
// import Login from '../views/login/login'
// import ErrorPage from '../views/error/error'
import Home from '../views/home/home'
import Pos from '../views/product/pos'
import Unattended from '../views/product/unattended'
import SupplyChain from '../views/product/supply'
import OnlineShop from '../views/product/online'
import Hardware from '../views/product/hardware'
import Payment from '../views/product/payment'

import UnmannedRetail from '../views/solution/unmannedRetail'
import SupermarketRetail from '../views/solution/supermarketRetail'
import ChainFranchise from '../views/solution/chainFranchise'
import AgriculturalMarket from '../views/solution/agriculturalMarket'

import AboutUs from '../views/aboutUs'
import CooperationChannel from '../views/cooperationChannel'
import DownloadCenter from '../views/downloadCenter'
import PayForKnowledge from '../views/PayForKnowledge'
import Login from '../views/login/login'
import Register from '../views/login/register'


import Affiliate from '../views/product/affiliate'


import NewsCenter from '../views/newsCenter'
// import MyExcel from '../views/excel'
import Cases from '../views/cases'
import OpenDoor from '../views/openDoor'
/**
 *  meta: {
      icon:'',  侧面菜单栏显示的图标
      title: '' 侧面菜单栏显示的标题
      hideInMenu: false, 是否显示菜单栏（注意只有在根路由下的子路由才有效！）
      access: [''], 用户权限控制，不填默认所有用户均可访问
    },
 * 
 */
const routes = [
{
    path: "/",     //侧面菜单栏的路由必须是根路由的子路由哦！
    name: 'first-page',
    component: Main,
    meta: {
        icon: 'home',
        title: '首页',
        hideInMenu: false,
        access: ['student'],
    },
    indexRoute: { component: Home },
    // onEnter: onRouteEnter
},
{
    path: "",
    name: 'person-page',
    component: Main,
    indexRoute: { component: Pos },
    // onEnter: onRouteEnter,
    meta: {
        icon: 'team',
        title: '产品中心',
        hideInMenu: false,
        access: ['student'],
    },
    childRoutes: [{
        path: "/product/pos",
        name: 'code-page',
        component: Pos,
        meta: {
            title: '收银POS系统',
            hideInMenu: false,
            access: ['student'],
        }
    }, {
        path: "/product/unattended",
        name: 'unattended-page',
        component: Unattended,
        meta: {
            title: '悦喵无人值守',
            hideInMenu: false,
            access: ['student'],
        }
    }, {
        path: "/product/affiliate",
        name: 'affiliate-page',
        component: Affiliate,
        meta: {
            title: '营销会员产品',
            hideInMenu: false,
            access: ['student'],
        }
    },
    {
        path: "/product/supply",
        name: 'supply-page',
        component: SupplyChain,
        meta: {
            icon: 'layout',
            title: '供应链订货系统',
            hideInMenu: false,
            access: ['student'],
        }
    },
    {
        path: "/product/payment",
        name: 'payment-page',
        component: Payment,
        meta: {
            icon: 'layout',
            title: '聚合支付系统',
            hideInMenu: false,
            access: ['student'],
        }
    }, {
        path: "/product/onlineShop",
        name: 'shop-page',
        component: OnlineShop,
        meta: {
            icon: 'layout',
            title: '线上商城',
            hideInMenu: false,
            access: ['student'],
        }
    }, {
        path: "/product/hardware",
        name: 'hardware-page',
        component: Hardware,
        meta: {
            icon: 'layout',
            title: '硬件服务',
            hideInMenu: false,
            access: ['student'],
        }
    }]
},
// {
//     path: "",
//     name: 'editor-page',
//     component: Main,
//     // indexRoute: { component: MyEditor },
//     // onEnter: onRouteEnter,
//     meta: {
//         icon: 'read',
//         title: '解决方案',
//         hideInMenu: false,
//         access: ['student'],
//     },
//     childRoutes: [{
//         path: "/unmannedRetail",
//         name: 'unmanned-page',
//         component: UnmannedRetail,
//         meta: {
//             title: '无人零售解决方案',
//             hideInMenu: false,
//             access: ['student'],
//         }
//     }, {
//         path: "/supermarketRetail",
//         name: 'supermarket-page',
//         component: SupermarketRetail,
//         meta: {
//             title: '商超零售解决方案',
//             hideInMenu: false,
//             access: ['student'],
//         }
//     }, {
//         path: "/chainFranchise",
//         name: 'chain-franchise',
//         component: ChainFranchise,
//         meta: {
//             title: '连锁加盟解决方案',
//             hideInMenu: false,
//             access: ['student'],
//         }
//     },
//     {
//         path: "/agriculturalMarket",
//         name: 'agricultural-market',
//         component: AgriculturalMarket,
//         meta: {
//             icon: 'layout',
//             title: '农贸市场解决方案',
//             hideInMenu: false,
//             access: ['student'],
//         }
//     }]
// }, 
// {
//     path: "/cases",
//     name: 'cases-page',
//     component: Main,
//     indexRoute: { component: Cases },
//     // onEnter: onRouteEnter,
//     meta: {
//         icon: 'file',
//         title: '合作案例',
//         hideInMenu: false,
//         access: ['student'],
//     }
// }, 
{
    path: "/news",
    name: 'news-page',
    component: Main,
    indexRoute: { component: NewsCenter },
    // onEnter: onRouteEnter,
    meta: {
        icon: 'global',
        title: '新闻中心',
        hideInMenu: false,
        access: ['student'],
    }
},
{
    path: "/antComponent",
    name: 'antComponent-page',
    // onEnter: onRouteEnter,
    component: Main,
    indexRoute: { component: AboutUs },
    meta: {
        icon: 'switcher',
        title: '关于我们',
        hideInMenu: false,
        access: ['student'],
    },
},
    {
    path: "/login",
    name: 'login-page',
    //     component: Login,
    // onEnter: onRouteEnter,
     indexRoute: { component: Login },
    meta: {
        icon: 'desktop',
        title: '登陆',
        hideInMenu: true,
    }
},
 {
    path: "/register",
    name: 'register-page',
    //     component: Login,
    // onEnter: onRouteEnter,
     indexRoute: { component: Register },
    meta: {
        icon: 'desktop',
        title: '注册',
        hideInMenu: true,
    }
},
// {
//     path: "/error_page",
//     name: 'error-page',
//     component: ErrorPage,
//     meta: {
//         icon: 'file',
//         title: '错误',
//         hideInMenu: true,
//     }
// }
    {
        path: "/cooperationChannel",
        name: 'cooperation-channel',
        component: Main,
        indexRoute: { component: CooperationChannel },
        meta: {
            icon: 'desktop',
            title: '合作渠道',
            hideInMenu: false,
        }
    },
    {
        path: "/downloadCenter",
        name: 'download-center',
        component: Main,
        indexRoute: { component: DownloadCenter },
        meta: {
            icon: 'desktop',
            title: '下载中心',
            hideInMenu: false,
        }
    },
    {
        path: "/payForKnowledge",
        name: 'pay-for-knowledge',
        // component: Main,
        indexRoute: { component: PayForKnowledge },
        meta: {
            icon: 'desktop',
            title: '联拓神策',
            hideInMenu: true,
        }
    },
    {
        path: "/openDoor",
        name: 'open-door',
        // component: Main,
        indexRoute: { component: OpenDoor },
        meta: {
            icon: 'desktop',
            title: '开门',
            hideInMenu: true,
        }
    },
]

const canChangeRouter = (route, access, callback, replace) => {
    if (canTurnTo(route, access)) {
    } else {
        replace({
            pathname: "/error_page"
        })
    }
}
function onRouteEnter(nextState, replace, callback) {
    const route = nextState.routes[nextState.routes.length - 1].path ? nextState.routes[nextState.routes.length - 1] : nextState.routes[0]
    const storeData = store.getState().userData
    const { access, hasGetInfo } = storeData
    let token = getToken()
    if (!token && route.path === '/login') {
    } else if (!token && route.path !== '/login') {
        replace({
            pathname: "/login"
        })
    } else if (token && route.path === '/login') {
        replace({
            pathname: "/"
        })
    } else {
        if (hasGetInfo) {
            canChangeRouter(route, access, callback, replace)
        }
    }
    addRouterHistory(route)
    callback()
}

export default routes


